import {aBank24forBusiness} from '../../services/urls/urls';

export const HEADER_HOVER_TIMEOUT = 250;
export const NAV_CONTEXT = {
    INDIVIDUAL: 'individual',
    BUSINESS: 'business'
};
export const loginBtnTypes = {
    business: {
        url: aBank24forBusiness,
        target: '_blank',
        text: 'NEW_HEADER_ABUSINESS'
    },
    default: {
        url: '/services/abank',
        target: '_self',
        text: 'NEW_HEADER_ABANK24'
    }
};
